export default __webpack_public_path__ + "static/media/yt.4e1a19f9.png";